import vue2Dropzone from 'vue2-dropzone';

export default {
  install: (Vue) => {
    Vue.component('vueDropZone', vue2Dropzone);
  },
};
